export default __webpack_public_path__ + "static/media/living-room-1835923_640.20c98355.jpg";